/* unplugin-vue-components disabled */import { render } from "./Navbar.vue?vue&type=template&id=6712b5e0"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lightandnight/lightandnight/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__